import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Auth } from 'aws-amplify';

import apiMethods from '../../../apis';
import { setUserValues } from '../../../store/slices/user';
import useGet from '../http/useGet';

export const loginUser = async (email, password) => {
  //const { username: userId, challengeName } = await Auth.signIn(email, password);
  const user = await Auth.signIn(email, password);

  if (!(user.challengeName === 'NEW_PASSWORD_REQUIRED')) {
    localStorage.setItem('loginISODate', new Date().toISOString());
  }
  return user;
};

export const logOutUser = async () => {
  let logOut = false;
  try {
    try {
      await Auth.signOut({ global: true });
    } catch (error) {
      await Auth.signOut();
    }
    logOut = true;
  } catch (error) {
    process.env.NODE_ENV === 'development' && console.log('Logout error', error);
  }
  return logOut;
};

const getAuthenticatedUser = async () => {
  let isAuthenticated = false;
  let userId = null;
  let email = null;
  try {
    const {
      attributes: { sub, email: userEmail }
    } = await Auth.currentAuthenticatedUser();
    isAuthenticated = true;
    userId = sub;
    email = userEmail;
  } catch (error) {}
  return { isAuthenticated, userId, email };
};

const useAuthentication = () => {
  const dispatch = useDispatch();

  // State
  const [isLoading, setLoading] = useState(true);

  // Global state
  const { isLogged, userId } = useSelector(state => state.userData);

  // User data fetch
  const shouldFetch = !!userId;
  const { isSuccess, data: userData, refetch } = useGet(apiMethods.getUser, [userId], shouldFetch);

  useEffect(() => {
    const validate = async () => {
      const { isAuthenticated, userId, email } = await getAuthenticatedUser();
      let shouldLogin = false;
      if (isAuthenticated) {
        const loginISODate = localStorage.getItem('loginISODate');
        if (loginISODate) {
          const loginDate = new Date(loginISODate);
          const hoursSinceLogin = (new Date() - loginDate) / 3600000;
          shouldLogin = hoursSinceLogin < 8;
        }
      }
      if (shouldLogin) {
        dispatch(setUserValues({ userId, email }));
      } else {
        localStorage.setItem('loginISODate', null);
        setLoading(false);
      }
    };
    validate();
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      const { profile, businesses } = userData;
      const { isInternational } = profile; // Extraer isInternational del profile
      const [businessId] = Object.keys(businesses);
      dispatch(setUserValues({ isLogged: true, profile, businesses, businessId, isInternational }));
      setLoading(false);
    }
  }, [dispatch, isSuccess, userData]);

  return { isLoading, isLogged, refetch };
};

export default useAuthentication;
